import * as React from "react";

// BASE Components
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
// Material UI
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Chip from "@mui/material/Chip";
import FavoriteIcon from "@mui/icons-material/Favorite";
import IconButton from "@mui/material/IconButton";
import ShareIcon from "@mui/icons-material/Share";
import Tooltip from "@mui/material/Tooltip";
import sx from "@mui/system/sx";

export default function ComponentCard(props) {
  const { title, description, id, commentsCount, children } = props;

  return (
    <Card className="square mb-24" elevation={0} variant="outlined">
      <CardHeader
        action={
          <>
            <Tooltip
              title={`${commentsCount ? commentsCount : 0} Comments`}
              placement="top"
            >
              <Chip
                icon={
                  <BASESvgIcon size={20} color="primary">
                    heroicons-outline:chat
                  </BASESvgIcon>
                }
                label={commentsCount ? commentsCount : 0}
                variant="contained"
                className="mx-16"
                sx={{
                  backgroundColor: "common.white",
                  color: "primary.dark",
                }}
              />
            </Tooltip>
            <Tooltip title="Add Comment" placement="top">
              <Button
                variant="contained"
                aria-label="Add Comment"
                component={NavLinkAdapter}
                to={`comments/new/edit?c=${id}&t=${title}`}
                size="small"
                sx={{
                  backgroundColor: "common.white",
                  color: "primary.dark",
                }}
              >
                <BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>
                <BASESvgIcon size={20}>heroicons-outline:chat</BASESvgIcon>
              </Button>
            </Tooltip>
          </>
        }
        title={title}
        titleTypographyProps={{ fontSize: 16, fontWeight: "bold" }}
        subheader={description}
        subheaderTypographyProps={{ fontSize: 14, color: "#B8BABF" }}
        sx={{ backgroundColor: "#111827", color: "#FFFFFF" }}
      />
      <CardContent className="p-0">{children}</CardContent>
      {/* <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
      </CardActions> */}
    </Card>
  );
}
